import cn from "clsx";
import { useTranslations } from "next-intl";

type SpineResultProps = {
  spine: string | number;
  className?: string;
};

export function SpineResult({ spine, className }: SpineResultProps) {
  const t = useTranslations("custom-attributes-forms");
  return (
    <div
      className={cn(
        "bg-grey-10 text-grey-90 flex flex-col items-center justify-center rounded p-3 text-center",
        className,
      )}
    >
      <p className="mb-2 text-base font-semibold md:text-lg lg:text-base 2xl:text-lg">
        {t("text-your-spine")}:
      </p>
      <p className="mb-2 text-xl font-extrabold md:text-2xl lg:text-xl 2xl:text-2xl">{`${spine}${t(
        "text-mm",
      )}`}</p>
      <p className="mb-0 text-xs italic md:text-sm lg:text-xs 2xl:text-sm">
        {t.rich("text-spine-description", { must: (t) => <b>{t}</b> })}
      </p>
    </div>
  );
}
